module.exports = __webpack_public_path__ + "static/media/logotipo-mds-security.3d5c0776.jpg";